import type { LandingConfig } from "@/components/landing/LandingContext";
import { landingParents } from "./landingParents";
import { landingReno } from "./landingReno";

/** Families / parents Meta-ads landing. */
export const parentsLandingConfig: LandingConfig = {
  copy: landingParents,
  frPath: "/parents-recus-retours",
  enPath: "/en/parents-receipts-returns",
  heroImage: "/parents-hero.jpg",
  analyticsPage: "parents_receipts_returns",
  appStorePpid: "f4aef2c2-ede9-4b55-8272-5db79288d86f",
};

/** Home-reno / DIY Meta-ads landing. */
export const renoLandingConfig: LandingConfig = {
  copy: landingReno,
  frPath: "/reno-recus-retours",
  enPath: "/en/home-reno-receipts-returns",
  // No reno hero photo uploaded yet → falls back to the app mockup (no broken image).
  heroImage: null,
  analyticsPage: "reno_receipts_returns",
  appStorePpid: "06efaf6f-83e7-42d8-9a97-ec55fdaa11e0",
};
